import { Html, Head, Main, NextScript } from 'next/document';
import { env } from '@/lib/env';

import { MODAL_ROOT_ID } from '@/constants/modal';

const DEFAULT_TITLE = '네이버 티켓·패키지';
const DEFAULT_AUTHOR = '네이버 티켓·패키지';
export const DEFAULT_IMAGE = `${env('PRIVATE_CDN_URL')}/pkgtour/assets/meta/og_image.png`;

export default function Document() {
  return (
    <Html lang="ko">
      <Head>
        <meta key="og:type" property="og:type" content="article" />
        <meta key="og:article:author" property="og:article:author" content={DEFAULT_AUTHOR} />
        <meta key="og:site_name" property="og:site_name" content={DEFAULT_TITLE} />
        <meta key="twitter:card" property="twitter:card" content="summary_large_image" />
        <meta key="twitter:title" property="twitter:title" content={DEFAULT_TITLE} />
        <meta key="twitter:site" property="twitter:site" content={DEFAULT_TITLE} />
        <meta key="twitter:image" property="twitter:image" content={DEFAULT_IMAGE} />
        <script src={`${env('APP_URL') || ''}/__ENV.js`} />
        <meta key="application-name" name="application-name" content="pkgtour-vertical-client" />
        <link rel="canonical" href={env('VERTICAL_SERVICE_URL')} />
      </Head>
      <body>
        <Main />
        <div id={MODAL_ROOT_ID}></div>
        {/* <!-- Naver Tag Manager --> */}
        {env('NTM_SCRIPT_URL') && (
          <script
            dangerouslySetInnerHTML={{
              __html: `!function(t,n){n=n||"ntm";window["ntm_"+t]=n,window[n]=window[n]||[],window[n].push({"ntm.start":+new Date});t=document.getElementsByTagName("script")[0],n=document.createElement("script");n.async=!0,n.src="${env('NTM_SCRIPT_URL')}",t.parentNode.insertBefore(n,t)}("4568ec45ff5b","ntm");`,
            }}
          ></script>
        )}
        {/* <!-- End Naver Tag Manager --> */}
        <NextScript />
      </body>
    </Html>
  );
}
